module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"New Company","input-1":"Corporate name","input-2":"Website","input-3":"Document","create":"Create company","custom-fields":"Custom fields"},"pt-BR":{"title":"Nova Empresa","input-1":"Razão social","input-2":"Website","input-3":"CNPJ","create":"Criar empresa","custom-fields":"Campos customizados"}}')
  delete Component.options._Ctor
}
